import axios from "axios";
import { getToken, removeTokens } from "./auth";

export const api = axios.create({
  baseURL: import.meta.env.REACT_APP_API_URL,
});

// Endpoints that require the public-status bearer token.
//
// `retailer/public-status/` is deliberately NOT in this list. Its backend
// (getbarcart `account/viewsets.py` ListPublicWarehouseStatusAPIView) treats a
// missing token as authorized, but a token it cannot resolve as a hard 403 --
// and unlike PublicOrderAuthenticationMixin it only understands a plaintext
// email on an exact order name, with no phone and no hash fallback. Sending a
// token there would break the address form for phone-authenticated customers.
// Add it back once that view reuses PublicOrderAuthenticationMixin.
const AUTHENTICATED_PATHS = [
  "order/public-status/cancel/",
  "order/public-status/update-order-information/",
];

api.interceptors.request.use(async (config) => {
  // config.headers['Access-Control-Allow-Origin'] = '*';
  const token = getToken();
  // config.url may be relative to baseURL or absolute, and may carry a query
  // string, so compare on the path alone rather than the raw value.
  const path = (config.url || "").split("?")[0].replace(/^https?:\/\/[^/]+/, "");

  if (token && AUTHENTICATED_PATHS.some((endpoint) => path.endsWith(endpoint))) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      removeTokens();
      // window.location.href = import.meta.env.REACT_APP_APP_URL
    }
    return Promise.reject(error);
  }
);
